import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

export const activateDocumentTemplateVersion = async (
  documentTemplateId: string,
  documentTemplateVersionId: string
): Promise<Response> => {
  const res = await fetcher(
    `${BASE_URL}/${documentTemplateId}/active-version/${documentTemplateVersionId}`,
    {
      method: 'POST',
    }
  );
  return res;
};
